import { useEffect, useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import classesK from '../kalkulatori.module.css'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'
import runCalculator from '../api/runCalculator'

const calculatorType = 'Procena tacnog rezultata'
const category = 'predictions'
const slug = 'football-correct-score'

const ProcenaTacnogRezultata = () => {
  const [error, setError] = useState(false)
  const [apiError, setApiError] = useState('')
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      kOdds: ['', '', ''],
      gOdds: ['', ''],
      stats: ['', '', '', '', '', ''],
    },

    results: {
      resultsK: ['', '', ''],
      doubleChance: ['', '', ''],
      resultsG: ['', '', ''],
      exactScore: {
        min: { decimal: '', rounded: '' },
        average: { decimal: '', rounded: '' },
        max: { decimal: '', rounded: '' },
        results: {
          min: { decimal: '', rounded: '' },
          average: { decimal: '', rounded: '' },
          max: { decimal: '', rounded: '' },
        },
      },
      teamStrength: {
        home: {
          attack: '',
          defense: '',
        },
        away: {
          attack: '',
          defense: '',
        },
        combined: {
          attack: '',
          defense: '',
        },
        matchup: {
          homeAttack_vs_awayDefense: '',
          homeDefense_vs_awayAttack: '',
        },
      },
    },
  })
  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        kOdds: ['', '', ''],
        gOdds: ['', ''],
        stats: ['', '', '', '', '', ''],
      },

      results: {
        resultsK: ['', '', ''],
        doubleChance: ['', '', ''],
        resultsG: ['', '', ''],
        exactScore: {
          min: { decimal: '', rounded: '' },
          average: { decimal: '', rounded: '' },
          max: { decimal: '', rounded: '' },
          results: {
            min: { decimal: '', rounded: '' },
            average: { decimal: '', rounded: '' },
            max: { decimal: '', rounded: '' },
          },
        },
        teamStrength: {
          home: {
            attack: '',
            defense: '',
          },
          away: {
            attack: '',
            defense: '',
          },
          combined: {
            attack: '',
            defense: '',
          },
          matchup: {
            homeAttack_vs_awayDefense: '',
            homeDefense_vs_awayAttack: '',
          },
        },
      },
    })
    setApiError('')
    setShowInputArea(true)
  }
  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = async () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    } else {
      const ok = await handleCalculate()
      if (!ok) {
        return
      }
    }

    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  const handleCalculate = async () => {
    const [ki1, kiX, ki2] = data.values.kOdds.map(parseFloat)
    const [ug02, ug3] = data.values.gOdds.map(parseFloat)
    const [
      domPlus,
      domMinus,
      domacinBrojUtakmica,
      gostPlus,
      gostMinus,
      gostBrojUtakmica,
    ] = data.values.stats.map(parseFloat)

    const body = {
      ki1,
      kiX,
      ki2,
      ug02,
      ug3,
      domPlus,
      domMinus,
      domacinBrojUtakmica,
      gostMinus,
      gostPlus,
      gostBrojUtakmica,
    }

    setLoading(true)
    setApiError('')

    try {
      const res = await runCalculator(category, slug, body)
      const s = res.stats
      const p = res.predictions
      const f = (v) => Number(v).toFixed(2)

      setData((prev) => ({
        ...prev,
        results: {
          resultsK: [f(p.homeWinPct), f(p.drawPct), f(p.awayWinPct)],
          doubleChance: [
            f(p.doubleChance1X),
            f(p.doubleChance12),
            f(p.doubleChanceX2),
          ],
          resultsG: [f(p.under25Pct), f(p.over25Pct), f(p.expectedTotalGoals)],
          exactScore: {
            min: {
              decimal: `${f(p.pessimisticHomeGoals)} : ${f(
                p.pessimisticAwayGoals
              )}\n( ${f(p.pessimisticHomeAdjusted)} : ${f(
                p.pessimisticAwayAdjusted
              )} )`,
              rounded: `${Math.round(p.pessimisticHomeRounded)} : ${Math.round(
                p.pessimisticAwayRounded
              )}\n( ${Math.round(p.pessimisticHomeAdjustedRounded)} : ${Math.round(
                p.pessimisticAwayAdjustedRounded
              )} )`,
            },
            average: {
              decimal: `${f(p.averageHomeGoals)} : ${f(
                p.averageAwayGoals
              )}\n( ${f(p.averageHomeAdjusted)} : ${f(
                p.averageAwayAdjusted
              )} )`,
              rounded: `${Math.round(p.averageHomeRounded)} : ${Math.round(
                p.averageAwayRounded
              )}\n( ${Math.round(p.averageHomeAdjustedRounded)} : ${Math.round(
                p.averageAwayAdjustedRounded
              )} )`,
            },
            max: {
              decimal: `${f(p.optimisticHomeGoals)} : ${f(
                p.optimisticAwayGoals
              )}\n( ${f(p.optimisticHomeAdjusted)} : ${f(
                p.optimisticAwayAdjusted
              )} )`,
              rounded: `${Math.round(p.optimisticHomeRounded)} : ${Math.round(
                p.optimisticAwayRounded
              )}\n( ${Math.round(p.optimisticHomeAdjustedRounded)} : ${Math.round(
                p.optimisticAwayAdjustedRounded
              )} )`,
            },
          },
          teamStrength: {
            home: {
              attack: f(s.homeGoalsScoredAvg),
              defense: f(s.homeGoalsConcededAvg),
            },
            away: {
              attack: f(s.awayGoalsConcededAvg),
              defense: f(s.awayGoalsScoredAvg),
            },
            combined: {
              attack: f(s.homeScoredAwayConcededAvg),
              defense: f(s.homeConcededAwayScoredAvg),
            },
            matchup: {
              homeAttack_vs_awayDefense: f(s.homeAwayScoredAvg),
              homeDefense_vs_awayAttack: f(s.homeAwayConcededAvg),
            },
          },
        },
      }))
      return true
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
      return false
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled || loading}>
            {loading
              ? 'Obračun u toku...'
              : showInputArea
              ? 'Prikaži rezultate'
              : 'Unesi obračunske podatke'}
          </button>
        </div>
        {apiError && (
          <div style={{ color: '#e23b3b', textAlign: 'center', marginTop: 8 }}>
            {apiError}
          </div>
        )}
        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upisi kvote za ishod utakmice
            </div>
            <OddsCalculator
              field={'kOdds'}
              data={data.values}
              setData={setData}
              labelPrefix={['KI 1', 'KI X', 'KI 2']}
              step={['0.1', '0.1', '0.1']}
              min={['0.1', '0.1', '0.1']}
              type={['number', 'number', 'number']}
              setError={setError}
              rows={3}
            />
            <div className={classesK.sectionTitle}>Upiši kvote za golove</div>
            <OddsCalculator
              field={'gOdds'}
              data={data.values}
              setData={setData}
              labelPrefix={['Manje od 2.5 ( UG 0-2 )', 'Više od 2.5 ( UG 3+ )']}
              rows={2}
              type={['number', 'number']}
              step={['0.1', '0.1']}
              min={['0.1', '0.1']}
              setError={setError}
            />
            <div className={classesK.sectionTitle}>
              Upiši br. golova / br. ut. za oba tima
            </div>
            <OddsCalculator
              field={'stats'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'DOM +  ( dom. dao golova)',
                'DOM -  ( dom. primio golova)',
                'DOM BR. ( dom. odigrao utakmica)',
                'GOST +  ( gost. dao golova)',
                'GOST -  ( gost. primio golova)',
                'GOST BR. ( gost. odigrao utakmica)',
              ]}
              type={[
                'number',
                'number',
                'number',
                'number',
                'number',
                'number',
              ]}
              step={['1', '1', '1', '1', '1', '1']}
              min={['0', '0', '1', '0', '0', '1']}
              rows={3}
              setError={setError}
            />
          </>
        )}
        {!showInputArea && (
          <div className={classesK.sectionResults}>
            <ResultsSection
              title={`Ishod utakmice`}
              subtitle={`Konačan ishod`}
              withPercent={true}
              results={data?.results?.resultsK.map((result) => `${result}%`)}
              names={['KI 1', 'KI X', 'KI 2']}
            />
            <ResultsSection
              title={'Dupla šansa'}
              subtitle={`Dvoznak`}
              withPercent={true}
              results={data?.results?.doubleChance.map(
                (result) => `${result}%`
              )}
              names={['KI 1X', 'KI 12', 'KI X2']}
            />
            <ResultsSection
              title={'Golovi'}
              subtitle={`Ukupno golova`}
              results={data?.results?.resultsG.map((result, index) =>
                index < 2 ? `${result}%` : result
              )}
              names={[
                'Manje od 2.5 ( UG 0-2 )',
                'Više od 2.5 ( UG 3+ )',
                'Gol prosek ( srednja predikcija )',
              ]}
            />
            <ResultsSection
              title={'Tačan rezultat'}
              subtitle={`Minimalan tačan rezultat`}
              results={[
                data.results?.exactScore?.min?.decimal,
                data.results?.exactScore?.min?.rounded,
              ]}
              withPercent={false}
              names={['Decimalan prikaz', 'Prikaz u celom broju']}
            />
            <ResultsSection
              subtitle={`Srednji tačan rezultat`}
              results={[
                data.results?.exactScore?.average?.decimal,
                data.results?.exactScore?.average?.rounded,
              ]}
              withPercent={false}
              names={['Decimalan prikaz', 'Prikaz u celom broju']}
            />
            <ResultsSection
              subtitle={`Maksimalan tačan rezultat`}
              results={[
                data.results?.exactScore?.max?.decimal,
                data.results?.exactScore?.max?.rounded,
              ]}
              withPercent={false}
              names={['Decimalan prikaz', 'Prikaz u celom broju']}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={`Snaga domaćina`}
              results={[
                data.results?.teamStrength?.home?.attack,
                data.results?.teamStrength?.home?.defense,
              ]}
              withPercent={false}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={`Snaga gosta`}
              results={[
                data.results?.teamStrength?.away?.attack,
                data.results?.teamStrength?.away?.defense,
              ]}
              withPercent={false}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={`Snage oba tima zajedno`}
              results={[
                data.results?.teamStrength?.combined?.attack,
                data.results?.teamStrength?.combined?.defense,
              ]}
              withPercent={false}
              names={[
                'SNDG ( snaga napada domaćina i gosta )',
                'SODG ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={`Tim proseci odbrana i napada`}
              results={[
                data.results?.teamStrength?.matchup?.homeAttack_vs_awayDefense,
                data.results?.teamStrength?.matchup?.homeDefense_vs_awayAttack,
              ]}
              withPercent={false}
              names={[
                'SND + SOG ( dom.daje/gost prima )',
                'SOD + SNG ( dom. prima/gost daje )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProcenaTacnogRezultata
